import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import WerselStory from "../components/newOurStory/index"
import { graphql } from "gatsby"

const OurStory = ({ data }) => (
  <Layout withBrand slidePosition={0}>
    <SEO
      description="Ecommerce analytics and business intelligence products from Wersel enable online retail owners to gain unmatched competitive edge embrace and drive meaningful traffic and sales to your business."
      keywords="wersel, wersel brand analytics, brand analytics platform, wersel data hub"
      title="Our Story - Wersel Workdesk"
      url="www.wersel.io/our-story"
    />
    <WerselStory
      webBanner={data?.webBanner?.childImageSharp?.fluid.src}
      mobBanner={data?.mobBanner?.childImageSharp?.fluid.src}
      firstImgHW={data?.firstImgHW?.childImageSharp?.fluid.src}
      secondImgHW={data?.secondImgHW?.childImageSharp?.fluid.src}
      thirdImgHW={data?.thirdImgHW?.childImageSharp?.fluid.src}
      webSolution={data?.webSolution?.childImageSharp?.fluid.src}
      mobSolution={data?.mobSolution?.childImageSharp?.fluid.src}
    />
  </Layout>
)
export const ourstoryQuery = graphql`
  query OurstoryQuery {
    webBanner: file(relativePath: { eq: "ourstoryAssets/Banner/Web.png" }) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    mobBanner: file(relativePath: { eq: "ourstoryAssets/Banner/Mobile.png" }) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    firstImgHW: file(
      relativePath: { eq: "ourstoryAssets/TheHowAndWhat/Img1.png" }
    ) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    secondImgHW: file(
      relativePath: { eq: "ourstoryAssets/TheHowAndWhat/Img2.png" }
    ) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    thirdImgHW: file(
      relativePath: { eq: "ourstoryAssets/TheHowAndWhat/Img3.png" }
    ) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    webSolution: file(
      relativePath: { eq: "ourstoryAssets/Influential/Web.png" }
    ) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    mobSolution: file(
      relativePath: { eq: "ourstoryAssets/Influential/Mobile.png" }
    ) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
  }
`

export default OurStory
